import {getUseQueryResultData} from "../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {LocationHistory, LocationHistoryEntity} from "../../model/location-history";

export type LocationHistorySelectorProps = {
  // selector props
};

export const locationHistoriesSelector = () => createSelector(
  [getUseQueryResultData<LocationHistory[]>],
  (data) => {
    return selectLocationHistoriesAndTransform(
      data ?? [], {});
  }
);

export const locationHistorySelector = () => createSelector(
  [getUseQueryResultData<LocationHistory>],
  (data) => {
    return data ? transformLocationHistory(data) : undefined;
  }
);

export const ticketLocationHistorySelector = () => createSelector(
  [getUseQueryResultData<LocationHistory>],
  (data) => {
    return data ? transformLocationHistory(data) : undefined;
  }
);

export const selectLocationHistories = (values?: LocationHistory[], selector?: LocationHistorySelectorProps): LocationHistory[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;
    return filterIn;
  });
};

export const transformLocationHistory = (value: LocationHistory): LocationHistoryEntity => {
  return LocationHistoryEntity.from(value)
}

export const selectLocationHistoriesAndTransform = (values?: LocationHistory[], selector?: LocationHistorySelectorProps): LocationHistoryEntity[] => {
  const selected = selectLocationHistories(values, selector);
  return selected.map(transformLocationHistory);
};
